import { createContext, Dispatch, useContext } from 'react';

import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { SaveFn } from '../hooks/usePropertySave';
import { SetSourceModeFn } from '../hooks/usePropertySourceMode';
import { PropertySettingsAction, PropertySettingsState } from '../state';

export type RegisterErrorRef = (
	sectionId: SETTINGS_SECTION_TYPES,
	element: HTMLElement | null
) => void;

export interface PropertySettingsContextValue {
	state: PropertySettingsState;
	dispatch: Dispatch<PropertySettingsAction>;
	isDirty: boolean;
	isListMode: boolean;
	isNew: boolean;
	propertyId: string;
	save: SaveFn;
	setSourceMode: SetSourceModeFn;
	goToProperty: (targetPropertyId: string) => void;
	submitSettings: (shouldCrawl: boolean) => Promise<void>;
	registerErrorRef: RegisterErrorRef;
}

const PropertySettingsContext = createContext<PropertySettingsContextValue | null>(null);

export const PropertySettingsProvider = PropertySettingsContext.Provider;

export function usePropertySettings(): PropertySettingsContextValue {
	const ctx = useContext(PropertySettingsContext);
	if (!ctx) {
		throw new Error('usePropertySettings must be used within a PropertySettingsProvider');
	}
	return ctx;
}
